/* eslint-disable import/prefer-default-export */
import { useState, useEffect, useCallback, useRef, useMemo } from 'react'
import { WidgetId } from 'features/types'
import { useAppSelector } from 'app/hooks'
import { WidgetType } from 'enums'
import { usePageConfigUser } from 'hooks/usePageConfig'
import { PostMetric } from 'schemas/PostMetricSchema'
import { getStreamDataFromPostMetric } from 'utils/streamDataUtil'

export const useTopLinkHasTooltip = () => {
  const [displayTopLinkTooltip, setTopLinkDisplayTooltip] = useState(false)
  const topLinkContentRef = useRef<HTMLDivElement>(null)

  const checkTopLinkContent = useCallback(() => {
    if (!topLinkContentRef.current) return
    const topLinkContent = topLinkContentRef.current
    // only display tooltip while title content is over 2 lines
    // each line height is 22px
    setTopLinkDisplayTooltip(topLinkContent.scrollHeight! > 44)
  }, [])

  useEffect(() => {
    checkTopLinkContent()
  })

  return { displayTopLinkTooltip, topLinkContentRef }
}

export const useBottomItemTooltip = () => {
  const [displayBottomItemTooltip, setBottomItemDisplayTooltip] = useState(false)
  const bottomItemContentRef = useRef<HTMLDivElement>(null)

  const checkBottomItemContent = useCallback(() => {
    if (!bottomItemContentRef.current) return
    const bottomItemContent = bottomItemContentRef.current
    setBottomItemDisplayTooltip(bottomItemContent.offsetWidth < bottomItemContent.scrollWidth)
  }, [])

  useEffect(() => {
    checkBottomItemContent()
  })

  return { displayBottomItemTooltip, bottomItemContentRef }
}

export const useSoundbites = (widgetId: WidgetId, targetUrl?: string) => {
  const widgetData = useAppSelector(({ widget }) => widget.dashboardWidgets[widgetId])
  const metricData = widgetData.data[0].results[0].data?.metrics?.filter((metric: PostMetric) =>
    metric?.mentionedUrls?.some((mentionedUrl) => mentionedUrl.url === targetUrl)
  )
  return metricData?.[0]
}

export const useStreamData = (data: PostMetric) => {
  const { timeZone } = usePageConfigUser()
  return useMemo(
    () =>
      getStreamDataFromPostMetric(data, timeZone, WidgetType.SOCIAL_WEB_POPULAR_LINKS, true, true),
    [data, timeZone]
  )
}
